var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F3EB200E-48AD-4073-A2E4-EB595F9C9C95") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-284.000000, -759.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(284.000000, 759.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EBEBEE",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8,29.1 C31.7,28 31,26.6 31,25 L31,22.1 C31,19.4 29.2,17 26.7,16.2 C27.2,15.2 27.3,14.8 27.3,14.5 C27.3,13.1 26.2,12 24.9,12 C23.6,12 22.5,13.1 22.5,14.4 C22.5,14.8 22.7,15.4 23.1,16.1 C20.6,16.9 18.8,19.2 18.8,22 L18.8,24.9 C18.8,26.5 18.1,27.9 17,29 C15.9,29 15,29.9 15,31 C15,32.1 15.9,33 17,33 L21.7,33 C21.7,34.8 23.2,36.2 24.9,36.2 C26.7,36.2 28.1,34.7 28.1,33 L32.8,33 C33.9,33 34.8,32.1 34.8,31 C34.9,29.9 34,29.1 32.8,29.1 L32.8,29.1 Z M24.9,13 C25.7,13 26.3,13.7 26.3,14.4 C26.3,14.5 26.2,14.9 25.7,15.9 C25.6,15.9 24.5,15.7 24,15.9 C23.5,14.9 23.4,14.6 23.4,14.4 C23.4,13.7 24.1,13 24.9,13 Z M19.7,25 L19.7,22.1 C19.7,19.3 22,16.9 24.9,16.9 C27.7,16.9 30.1,19.2 30.1,22.1 L30.1,25 C30.1,26.5 30.6,27.9 31.5,29.1 L18.3,29.1 C19.2,27.9 19.7,26.4 19.7,25 L19.7,25 Z M27.1,33.1 C27.1,34.3 26.1,35.3 24.9,35.3 C23.7,35.3 22.7,34.3 22.7,33.1 L27.1,33.1 Z M32.8,32.1 L16.9,32.1 C16.3,32.1 15.9,31.6 15.9,31.1 C15.9,30.5 16.4,30.1 16.9,30.1 L32.8,30.1 C33.4,30.1 33.8,30.6 33.8,31.1 C33.9,31.7 33.4,32.1 32.8,32.1 L32.8,32.1 Z",
    id: "Shape",
    stroke: "#000000",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.d2d4f52a43a8e284db7e32c730687220.svg";
export { ForwardRef as ReactComponent };